var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-card',[_c('v-card-title',[_vm._v("Resumen del Dashboard")]),_c('v-card-text')],1)],1),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-card',[_c('v-card-title',[_vm._v("Gráficos e Información")]),_c('v-card-text')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }